// extracted by mini-css-extract-plugin
export var root = "H_v9";
export var wrapper = "H_wb";
export var image = "H_wc d_w d_y d_W";
export var imageWithHeight = "H_wd";
export var crop = "H_wf";
export var round = "H_wg";
export var fixedHeight = "H_wh";